import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { openDialog } from '../base/dialog/actions';
import { PAY_ACTIVE, SET_PAY_CONTROLLER, SET_RECEIVER_PAY_ENABLED, SET_RECEIVER_PAY_TRANSPORT, SET_REQUESTED_PAY_PARTICIPANT } from './actionTypes';
//@ts-ignore
import PayDialog from './components/PayDialog';
import { EVENTS, PERMISSIONS_ACTIONS, PAY_MESSAGE_NAME, } from './constants';
import { sendPayEndpointMessage } from './functions';
import logger from './logger';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { showNotification } from '../notifications/actions';
import { PARTICIPANT_UPDATED } from '../base/participants/actionTypes';
let receiverEndpointMessageListener;
export function openPayAuthorizationDialog(participantId, payUrl) {
    return openDialog(PayDialog, { participantId, payUrl });
}
export function setPayActive(active) {
    return (dispatch, getState) => {
        const state = getState();
        const { active: oldActive } = state['features/pay-service-charge'];
        const { conference } = state['features/base/conference'];
        if (active !== oldActive) {
            dispatch({
                type: PAY_ACTIVE,
                active
            });
            conference?.setLocalParticipantProperty('paySessionStatus', active);
        }
    };
}
export function sendrequestPay(userId, url) {
    return (dispatch, getState) => {
        const state = getState();
        logger.log(`Requsting pay permissions from: ${userId}`);
        dispatch({
            type: PARTICIPANT_UPDATED,
            participant: {
                userId,
                supportsPayment: true
            }
        });
        const { conference } = state['features/base/conference'];
        dispatch({
            type: SET_REQUESTED_PAY_PARTICIPANT,
            requestedParticipant: userId
        });
        if (!sendPayEndpointMessage(conference, userId, url, {
            type: EVENTS.permissions,
            action: PERMISSIONS_ACTIONS.request
        })) {
        }
    };
}
export function endpointMessageReceived(participantId, message) {
    return (dispatch, getState) => {
        const { action, name, type } = message;
        if (name !== PAY_MESSAGE_NAME) {
            return;
        }
        dispatch(openPayAuthorizationDialog(participantId, message.payUrl));
        dispatch(Close());
    };
}
export function enableReceiver() {
    return (dispatch, getState) => {
        const state = getState();
        const { enabled } = state['features/pay-service-charge'].receiver;
        if (enabled) {
            return;
        }
        const { connection } = state['features/base/connection'];
        const { conference } = state['features/base/conference'];
        if (!connection || !conference) {
            return;
        }
        dispatch({
            type: SET_RECEIVER_PAY_ENABLED,
            enabled: true
        });
        connection.addFeature('/pay-service-charge', true);
        receiverEndpointMessageListener = (participant, message) => {
            dispatch(endpointMessageReceived(participant.getId(), message));
        };
        conference.on(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, receiverEndpointMessageListener);
    };
}
export function setReceiverTransport(transport) {
    return {
        type: SET_RECEIVER_PAY_TRANSPORT,
        transport
    };
}
export function Close() {
    return (dispatch, getState) => {
        const state = getState();
        const { enabled } = state['features/pay-service-charge'];
        if (!enabled) {
            return;
        }
        const { connection } = state['features/base/connection'];
        const { conference } = state['features/base/conference'];
        if (!connection || !conference) {
            return;
        }
        logger.log('payment receiver disabled.');
        dispatch({
            type: SET_RECEIVER_PAY_ENABLED,
            enabled: false
        });
        dispatch(stopPayReceiver(true));
        connection.removeFeature('/pay-service-charge');
        conference.off(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, receiverEndpointMessageListener);
    };
}
export function stopPayReceiver(dontNotifyLocalParty = false, dontNotifyRemoteParty = false) {
    return (dispatch, getState) => {
        const state = getState();
        const { receiver } = state['features/pay-service-charge'];
        const { controller, transport } = receiver;
        if (!controller) {
            return;
        }
        const { conference } = state['features/base/conference'];
        if (!dontNotifyRemoteParty) {
            sendPayEndpointMessage(conference, controller, "", {
                type: EVENTS.stop
            });
        }
        dispatch({
            type: SET_PAY_CONTROLLER,
            controller: undefined
        });
        transport.sendEvent({
            name: PAY_MESSAGE_NAME,
            type: EVENTS.stop
        });
        dispatch(setPayActive(false));
        if (!dontNotifyLocalParty) {
            dispatch(showNotification({
                descriptionKey: 'dialog.remoteControlStopMessage',
                titleKey: 'dialog.remoteControlTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        }
    };
}
